import { useAppSelector } from '@reducers/index';
import { compare } from 'compare-versions';
import { useMemo } from 'react';
function useIsPluginVersion(expected_version) {
    const { version } = useAppSelector(state => ({ version: state.settings.version }));
    const isMatching = useMemo(() => {
        if (!version)
            return false;
        return compare(version, expected_version, '>=');
    }, [version, expected_version]);
    return isMatching;
}
export default useIsPluginVersion;
